// extracted by mini-css-extract-plugin
export default {"header":"PopOver_header__+kljT","close":"PopOver_close__gCuP3"};